import { adminPanelTranslation } from '@/assets/locales/views/adminPanel/adminPanel.translation.pl.ts';
import { areaTranslation } from '@/assets/locales/views/area/area.translation.pl.ts';
import { certificationTranslation } from '@/assets/locales/views/certification/certification.translation.pl.ts';
import { contactTranslation } from '@/assets/locales/views/contact/contact.translation.pl.ts';
import { employeeProfileTranslation } from '@/assets/locales/views/employeeProfile/employeeProfile.translation.pl.ts';
import { employeeProfilesListTranslation } from '@/assets/locales/views/employeeProfilesList/employeeProfilesSearch.translation.pl.ts';
import { examineeExamTranslation } from '@/assets/locales/views/examineeExam/examineeExam.translation.pl.ts';
import { landingPageTranslation } from '@/assets/locales/views/landingPage/landingPage.translation.pl.ts';
import { maintenancePageTranslation } from '@/assets/locales/views/MaintenancePage/MaintenancePage.translation.pl.ts';
import { myProfileTranslation } from '@/assets/locales/views/myProfile/myProfile.translation.pl.ts';
import { nestedStructureTranslation } from '@/assets/locales/views/nestedStructure/nestedStructure.translation.pl.ts';
import { notificationsTranslation } from '@/assets/locales/views/notifications/notifications.translation.pl.ts';
import { organizationChartTranslation } from '@/assets/locales/views/organizationChart/organizationChart.translation.pl.ts';
import { practicalExamShareTranslation } from '@/assets/locales/views/practicalExamShare/practicalExamShare.translation.pl.ts';
import { successionTranslation } from '@/assets/locales/views/succession/succession.translation.pl.ts';
import { surveyFillTranslation } from '@/assets/locales/views/surveyFill/surveyFill.translation.pl.ts';
import { teamTranslation } from '@/assets/locales/views/team/team.translation.pl.ts';
import { testFillTranslation } from '@/assets/locales/views/testFill/testFill.translation.pl.ts';
import { uploadEmployeesTranslation } from '@/assets/locales/views/uploadEmployees/uploadEmployees.translation.pl.ts';
import { uploadsHistoryTranslation } from '@/assets/locales/views/uploadsHistory/uploadsHistory.translation.pl.ts';
import { usersListTranslation } from '@/assets/locales/views/usersList/usersList.translation.pl.ts';
import { ViewsTranslation } from '@/assets/locales/views/views.translation.en.ts';

export const viewsTranslation: ViewsTranslation = {
  adminPanel: adminPanelTranslation,
  area: areaTranslation,
  certification: certificationTranslation,
  contact: contactTranslation,
  employeeProfile: employeeProfileTranslation,
  employeeProfilesList: employeeProfilesListTranslation,
  examineeExam: examineeExamTranslation,
  landingPage: landingPageTranslation,
  maintenancePage: maintenancePageTranslation,
  myProfile: myProfileTranslation,
  nestedStructure: nestedStructureTranslation,
  notifications: notificationsTranslation,
  organizationChart: organizationChartTranslation,
  practicalExamShare: practicalExamShareTranslation,
  succession: successionTranslation,
  surveyFill: surveyFillTranslation,
  team: teamTranslation,
  testFill: testFillTranslation,
  uploadEmployees: uploadEmployeesTranslation,
  uploadsHistory: uploadsHistoryTranslation,
  usersList: usersListTranslation,
};
